import { css } from '@emotion/react'

import colors from 'design-system/tokens/colors'

const formsStyles = css`
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    margin-bottom: 20px;
    color: #333;
    line-height: inherit;
  }

  button,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  input[type='search'] {
    appearance: none;
    box-sizing: border-box;
  }

  input[type='radio'],
  input[type='checkbox'] {
    margin: 0;
    margin-top: 4px;
    line-height: normal;
  }

  /* bootstrap carryover */
  .form-control {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.428571429;
    color: rgb(85.425, 85.425, 85.425);
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition:
      border-color ease-in-out 0.15s,
      box-shadow ease-in-out 0.15s;

    &[disabled],
    fieldset[disabled] & {
      background-color: ${colors.grays.l6};
      cursor: not-allowed;
      opacity: 1;
    }
  }
  textarea.form-control {
    height: auto;
  }
  /* bootstrap carryover */
`

export default formsStyles
